import { normalizeApiListResponse } from '../utils/apiListNormalize';

/** @deprecated Use normalizeApiListResponse from utils/apiListNormalize */
export const extractArrayFromApiResponse = normalizeApiListResponse;

export const filterValidCourseCategories = (categories = []) =>
  categories.filter((cat) => {
    const hasCategoryCode = cat.categoryCode && cat.categoryCode.trim() !== '';
    const hasCategoryType = cat.categoryType;
    return hasCategoryCode && hasCategoryType;
  });

export const mapCourseModulesFromCourse = (courseData) => {
  const modules = courseData.courseModules || courseData.trainingModules || [];
  return modules.map((cm, idx) => ({
    moduleId: cm.moduleId || cm.module?.id || cm.id,
    moduleName: cm.module?.moduleName || cm.moduleName,
    order: cm.order !== undefined ? cm.order : idx
  }));
};

export const buildCourseSubmitData = (formData) => {
  if (!formData.courseName || !formData.courseName.trim()) {
    return { error: 'Course name is required' };
  }

  const categoryId = parseInt(formData.categoryId, 10);
  if (!categoryId || Number.isNaN(categoryId) || categoryId < 1) {
    return { error: 'Please select a valid course category' };
  }

  const submitData = {
    courseName: formData.courseName.trim(),
    categoryId,
    deliveryMode: formData.deliveryMode || 'Online',
    isActive: formData.isActive !== undefined ? formData.isActive : true
  };

  if (formData.courseCode && formData.courseCode.trim()) {
    submitData.courseCode = formData.courseCode.trim().toUpperCase();
  }

  if (formData.description && formData.description.trim()) {
    submitData.description = formData.description.trim();
  }

  if (formData.durationDays && formData.durationDays.trim()) {
    const duration = parseInt(formData.durationDays, 10);
    if (!Number.isNaN(duration) && duration > 0) {
      submitData.durationDays = duration;
    }
  }

  if (formData.deliveryMode === 'Offline' && formData.offlineCenter && formData.offlineCenter.trim()) {
    submitData.offlineCenter = formData.offlineCenter.trim();
  }

  return { submitData };
};

export const getCourseCategoryDisplayName = (category) => {
  if (!category) return 'N/A';
  const catName = category.categoryName || category.name || '';
  const catCode = category.categoryCode || category.code || '';
  return catCode ? `${catName} - ${catCode}` : catName;
};
